module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp13_0.ce37112d.png";